// Copyright (c) Bentley Systems
import * as React from "react";
import {
  InformationPanel,
  InformationPanelBody,
  InformationPanelContent,
  InformationPanelHeader,
  Text,
} from "@itwin/itwinui-react";
import Eform from "../../Eform/Eform";

type EtreeRolloutPanelProps = {
  fRollUrl: string | undefined;
  infoPanelHeader: string | undefined;
  onFrollClose: (shouldRefreshTree: boolean) => void;
  navigateToInfPanelFunction: (navFrolUrl: string) => void;
  onSetInfoPanelHeader: (h: string) => void;
  propertyForFrollRefresh: boolean;
  wasEformChangedAndRefreshed: boolean;
};

const EtreeRolloutPanel = ({
  fRollUrl,
  infoPanelHeader,
  onFrollClose,
  navigateToInfPanelFunction,
  onSetInfoPanelHeader,
  propertyForFrollRefresh,
  wasEformChangedAndRefreshed,
}: EtreeRolloutPanelProps) => {
  const getFormIdFromFrollNavUrl = React.useMemo(() => {
    if (!fRollUrl) return undefined;
    const parts = fRollUrl.split("/");
    return parts.length > 2 ? parts[2] : undefined;
  }, [fRollUrl]);

  const getParamsFromFrollNavUrl = React.useMemo(() => {
    if (!fRollUrl) return undefined;
    const parts = fRollUrl.split("/");
    return parts.length > 3 ? parts[3] : undefined;
  }, [fRollUrl]);

  return (
    <InformationPanel
      resizable
      isOpen={fRollUrl !== undefined}
      style={{
        width: "40%",
        maxWidth: "70%",
        minWidth: "10%",
        zIndex: 100,
      }}
      className="iui-infoPanel"
    >
      <InformationPanelHeader style={{ padding: 0 }}>
        <div className="becs-all-margin">
          <Text variant="title">{infoPanelHeader}</Text>
        </div>
      </InformationPanelHeader>
      <InformationPanelBody style={{ padding: 0 }}>
        <InformationPanelContent
          displayStyle="default"
          style={{ padding: 0, height: "100%" }}
        >
          {fRollUrl && (
            <Eform
              isFromUrl={false}
              id={getFormIdFromFrollNavUrl}
              params={getParamsFromFrollNavUrl}
              closeFrollFunction={onFrollClose}
              navigateToInformationPanelFunction={navigateToInfPanelFunction}
              setInforPanelHeaderFunction={onSetInfoPanelHeader}
              refreshInRollOutWindowProperty={propertyForFrollRefresh}
              wasEformChangedAndRefreshed={wasEformChangedAndRefreshed}
            />
          )}
        </InformationPanelContent>
      </InformationPanelBody>
    </InformationPanel>
  );
};

export default EtreeRolloutPanel;
